export default function initModelMedia()
{
    const root = document.querySelector('[data-js="models"]');
    if (!root) return;

    function show(panel, target)
    {
        panel.querySelectorAll('[data-media]').forEach((media) =>
        {
            media.hidden = media.dataset.media !== target;
        });

        panel.querySelectorAll('[data-media-target]').forEach((btn) =>
        {
            const pressed = btn.dataset.mediaTarget === target;
            btn.classList.toggle('models__action--active', pressed);
            btn.setAttribute('aria-pressed', String(pressed));
        });
    }

    // Delegación: un solo listener para todos los paneles
    root.addEventListener('click', (e) =>
    {
        const btn = e.target.closest('[data-media-target]');
        const panel = btn?.closest('.models__panel');
        if (!btn || !panel) return;

        // Pulsar el piso activo vuelve a la fachada
        const isActive = btn.getAttribute('aria-pressed') === 'true';
        show(panel, isActive ? 'facade' : btn.dataset.mediaTarget);
    });
}
